import React from "react";
import { useQuery } from "react-query";

import SuzukiBike from "./SuzukiBike";

const Suzuki = () => {
  const { isLoading, data: bikes } = useQuery({
    queryKey: ["Bikes Suzuki"],
    queryFn: () =>
      fetch(
        "https://bike-resell-server-hasanalibd.vercel.app/bikes/Suzuki"
      ).then((res) => res.json()),
  });
  console.log(bikes);

  return (
    <>
      <div>
        {bikes?.map((bike) => (
          <SuzukiBike key={bike._id} bike={bike}></SuzukiBike>
        ))}
      </div>
    </>
  );
};

export default Suzuki;
